module.exports = __webpack_public_path__ + "c_static/img/2-5淘宝-查看评价.a561cb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/电脑端轨迹加权/2-5淘宝-查看评价.jpg
// module id = WPiq
// module chunks = 33